<script>
    import { getAssetURL } from "../common/assets";
    import Icon from "fa-svelte";
    import { faCheck } from "@fortawesome/free-solid-svg-icons";
    import { getLocalizedField } from "../common/lang";

    export let doc;
    export let form;
    export let selected = false;

    $: fields = form && form.fields;

    $: titleField = fields && fields.find(({ title }) => title);
    $: subtitleField = fields && fields.find(({ subtitle }) => subtitle);
    $: pictureField = fields && fields.find(({ picture }) => picture);

    $: title = titleField && getLocalizedField(doc[titleField.id]);
    $: subtitle = subtitleField && getLocalizedField(doc[subtitleField.id]);
    $: picture = pictureField && getLocalizedField(doc[pictureField.id]);
</script>

<style>
    .rounded-xl {
        max-width: 15em;
        height: 15em;
    }
</style>

<div
    class="border-2 rounded-xl elevation-2 overflow-hidden flex flex-col"
    class:border-blue-500={selected}
    on:click>
    {#if picture}
        <img
            src={getAssetURL(picture)}
            class="object-cover w-full"
            alt={title} />
    {/if}
    <span class="font-semibold p-4">{title}</span>
    {#if subtitle}<span class="text-sm p-4">{subtitle}</span>{/if}
    {#if selected}
        <div
            class="flex justify-center items-center bg-blue-500
                text-white rounded-full w-16 h-16 absolute text-xl mt-1 ml-1">
            <Icon icon={faCheck} />
        </div>
    {/if}
</div>
